export default {
  'disputes.menuTitle': 'Disputes',
};
